<template>
  <div background-color="primary">
    <v-container fluid grid-list-xl>
      <v-layout>
        <v-flex xs12 xl12 md12 sm12 lg12 class="mt-4">
          <div class="title text-xs-center form-divider margin-top-40px">
            <v-btn color="primary" dark large outline flat>ثبت مسابقه جدید</v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-form ref="NewSystemUserForm" v-model="NSUFvalid" lazy-validation class="margin-top-40px">
        <v-layout row wrap>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="Race.name"
              :rules="nameRules"
              solo
              placeholder="نام مسابقه"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="Race.name"
              :rules="nameRules"
              solo
              placeholder=" شهر"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-select solo :items="raceType" placeholder="نوع مسابقه را انتخاب کنید"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-select solo :items="prices" placeholder="قیمت مسابقه را انتخاب کنید"></v-select>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="Race.capacity"
              :rules="ncRules"
              solo
              placeholder="ظرفیت را وارد کنید"
              append-icon="credit_card"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="Race.phone"
              :rules="userTelRules"
              mask="phone"
              solo
              class="text-xs-left"
              prepend-inner-icon="call"
              style="direction: ltr"
              prefix="+98"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="Race.email"
              solo
              placeholder="پست الکترونیکی "
              class="ltr"
              mask
              hint="yourname@example.com"
              append-icon="email"
              clearable
              :rules="userEmailRules"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <!-- <v-text-field v-show='false' type="file" ref="file" v-model="DRVIMAGE"
                                    style="display: none" solo placeholder="عکس" prepend-inner-icon="add_a_photo"
                                    class="ltr">
            </v-text-field>-->
            <input type="file" ref="file" @change="onFileChanged" style="display: none" />
            <v-btn @click="$refs.file.click()" class="white lighten-1 ml-4 bt" style="width: 100%">
              <v-icon>add_a_photo</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4 style="margin-top:-25px">
            <v-flex lg6 style="margin-right:65px">
              <date-picker placeholder="تاریخ شروع" v-model="Race.startDate"></date-picker>
            </v-flex>
            <v-flex lg6 style="margin-right:65px">
              <date-picker placeholder="تاریخ پایان" v-model="Race.endDate"></date-picker>
            </v-flex>
          </v-flex>

          <v-flex xs12 sm6 md6 xl12 lg12>
            <v-btn
              block
              color="indigo"
              class="bt"
              dark
              :loading="userRegisterLoading"
              @click="create(Race)"
            >
              <v-icon>done</v-icon>ثبت
            </v-btn>
            <div class="danger-alert" v-if="error">{{error}}</div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: null,
      enabledUsers: [],
      Race: {
        name: null,
        type: null,
        city: null,
        startDate: null,
        endDate: null,
        price: null,
        capacity: null,
        period: null,
        image: null,
        phone: null,
        email: null
      },
      NSUFvalid: false,
      userRegisterLoading: false,
      userDataTableLoading: false,
      userDeletedDataTableLoading: true,
      UserTableDeletedItem: [],
      confirmRecovery: false,
      idRules: [v => !!v || " شماره شناسنامه ضروری است"],
      nationalCodeRules: [
        v => !!v || "کد ملی فیلد ضروری است",
        v => (v && v.length == 10) || "کد ملی باید ده رقمی باشد"
      ],
      numRules: [v => !!v || "این فیلد ضروری است"],
      ncRules: [
        v => !!v || "این فیلد ضروری است",
        v => (v && v.length >= 3) || "حداقل 3 رقم"
      ],
      nameRules: [
        v => !!v || "نام و نام خانوادگی الزامی میباشد",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      nameclass: [
        v => !!v || "کلاس مورد نظر را مشخص کنید",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      userTelRules: [
        v => !!v || "تلفن همراه الزامی میباشد",
        v => (v && v.length == 10) || "تلفن همراه وارد شده صحیح نمیباشد"
      ],
      userEmailRules: [
        v => !!v || "پست الکترونیکی الزامی میباشد",
        v => /.+@.+/.test(v) || "پست الکترونیکی وارد شده صحیح نمیباشد"
      ],
      userNameRules: [
        v => !!v || "نام کاربری الزامی میباشد",
        v => (v && v.length >= 5) || "نام کاربری باید حد اقل 5 کاراکتر باشد",
        v => /[A-Za-z&0-9]/.test(v) || "نام کاربری وارد شده صحیح نمیباشد"
      ],
      userPermissionRules: [v => !!v || "تعیین دسترسی های کاربر الزامی میباشد"],
      raceType: ["نوع یک", "نوع دو", "نوع سه"]
    };
  },
  methods: {
    onFileChanged(event) {
      this.User.image = event.target.files[0];
    },
    async getAllEnabled() {
      this.enabledUsers = (await AgentService.index()).data;
    },
    async create(user) {
      let res;
      var msg = "";
      this.error = null;
      // const areAllFieldsFilledIn = Object.keys(this.Race).every(
      //   key => !!this.User[key]
      // );
      // if (!areAllFieldsFilledIn) {
      //   this.error = "لطفا تمامی فیلد هارا پر کنید";
      //   return;
      // }
      try {
        let formData = new FormData();
        formData.append("image", user.image);
        // user.image = formData
        let body = {
          name: user.name,
          no: user.no,
          codeMelli: user.codeMelli,
          phone: user.phone,
          email: user.email,
          username: user.username,
          password: user.password,
          image: formData,
          nfcCount: user.nfcCount,
          startNumber: user.startNumber,
          endNumber: user.endNumber
        };

        // let res = await AgentService.post(user);
        // console.log(res);
        // if (res == 1) {
        //   msg = "=>DONE";
        // } else if (res == 0) {
        //   msg = "=>FAILED";
        // }
        // console.log(msg);
        console.log((this.Race.startDate).replace(/\//g,"-") + (this.Race.endDate).replace(/\//g, "-") );
        
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    date: function() {
      console.log(this.User.date);
    }
  }
};
</script>

<style scoped>
.danger-alert {
  color: red;
}
.margin-top-40px {
  margin-top: 40px;
}
.bt {
  height: 48px;
  margin: 0;
  width: 100%;
}
</style>
